<template>
    <checkbox
        :label="label"
        :class="['button-time-modal', {'disabled' :timeSlot.state === TimeSlotState.FULL || timeSlot.state === TimeSlotState.PAST}]"
        :label-left="true"
        label-class="time-modal-option"
        :radio="true"
        :checked="selected"
        @change="$emit('selected')"
        :disabled="timeSlot.state === TimeSlotState.FULL || timeSlot.state === TimeSlotState.PAST"
    ></checkbox>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import TimeSlot, { TimeSlotState } from '@/models/time-slot';
import Checkbox from '@/components/common/ui/Checkbox.vue';
import { OrderRetrievalMethod } from '@/stores/modules/time-scheduler';
import TimeSchedulerModule from '@/stores/modules/time-scheduler';
import { getModule } from 'vuex-module-decorators';

@Component({
    components: { Checkbox }
})
export default class TimeSlotEntry extends Vue
{
    @Prop(Object)   readonly timeSlot!: TimeSlot;
    @Prop(Boolean)  readonly current!: boolean;
    @Prop(Boolean)  readonly selected!: boolean;
    @Prop(String)   readonly retrievalMethod!: OrderRetrievalMethod;
    timeSchedulerModule!: TimeSchedulerModule;

    created() {
        this.timeSchedulerModule = getModule(TimeSchedulerModule, this.$store);
    }
    get TimeSlotState() {
        return TimeSlotState;
    }

    get label() {
        if (this.retrievalMethod === OrderRetrievalMethod.DELIVERY) {
            const start = new Date(this.timeSlot.start().getTime() + this.timeSchedulerModule.deliveryTime * 60 * 1000);
            const end = new Date(this.timeSlot.end().getTime() + this.timeSchedulerModule.deliveryTime * 60 * 1000);
            return start.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) + ' to ' + end.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        }
        const label = this.timeSlot.parsedStart + ' to ' + this.timeSlot.parsedEnd;
        if (this.timeSlot.state === TimeSlotState.FULL) return label + ' (Full)';
        return label;
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.button-time-modal {
    position: relative;
    width: 100%;
    padding: 16px 30px !important;
    border-bottom: 1px solid var(--time-modal-separator-color);
    text-align: left;
    border-radius: 0px;
    cursor: pointer;
    user-select: none;
    &:hover {
        background: var(--time-modal-list-hover-bg);
    }
    &.selected {
        .custom-checkbox-container {
            &:before {
                display: block;
            }
        }
    }
    &.disabled {
        opacity: .5;
        cursor: default;
        pointer-events: none;
    }
}
</style>
